import createUrlBuilder from 'utilities/url.builder.utils';
import { postRequest, getRequest, putRequest } from 'utilities/service.utils';
import AppService from './app.service.context';

export const createCheckoutSession = async (payload: any) => {
  const urlBuilder = createUrlBuilder(`/payment/checkout`).toString();

  return await postRequest(AppService, urlBuilder, payload);
};

export const getPaymentTypePrice = async (paymentType: string) => {
  const url = createUrlBuilder(`/payment/prices/${paymentType}`).toString();
  return await getRequest(AppService, url);
};

export const getCheckoutSessionStatus = async (sessionId: string) => {
  const url = createUrlBuilder(
    `/payment/checkout/status/${sessionId}`
  ).toString();
  return await getRequest(AppService, url);
};

export const createBelCheckoutSession = async (payload: {
  paymentType: string;
  returnUrl: string;
  quantity: number;
  metaData?: { [key: string]: string };
}) => {
  const url = createUrlBuilder(`/payment/checkout`).toString();
  return await postRequest(AppService, url, payload);
};

export const confirmPostPayment = async (
  postPaymentId: number,
  recaptchaToken: string,
  purchaseOrderNumber?: string
) => {
  const url = createUrlBuilder(
    `/payment/post/paid/confirm/${postPaymentId}`
  ).toString();
  return await putRequest(AppService, url, {
    recaptchaToken,
    purchaseOrderNumber:
      purchaseOrderNumber?.trim().replaceAll(' ', '') || undefined
  });
};
